import React from 'react'
import moment from 'moment';
import {
  TableRow,
  TableCell,
} from '@material-ui/core';
import { printStatus } from 'utils/tools';

const InternalInfo = props => {
  const { order } = props;
  return (
    <>
      <TableRow>
        <TableCell>Consumer</TableCell>
        <TableCell>
          <div>{order.consumer.name}</div>
          <div>{order.consumer.email}</div>
          <div>{order.consumer.phoen}</div>
        </TableCell>
      </TableRow>
      <TableRow selected>
        <TableCell>ID</TableCell>
        <TableCell>#{order.id}</TableCell>
      </TableRow>
      <TableRow selected>
        <TableCell>Date</TableCell>
        <TableCell>
          {moment(order.date).format('YYYY/MM/DD HH:MM')}
        </TableCell>
      </TableRow>
      <TableRow selected>
        <TableCell>Total Amount</TableCell>
        <TableCell>
          $
          {order.total_price_bt}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Status</TableCell>
        <TableCell>
          {printStatus(order.status)}
        </TableCell>
      </TableRow>
    </>
  )
}

export default InternalInfo;